import type { ContentNode, DocumentState } from '../document-types';
import type { NodeHandler, RenderContext } from './types';

export class DocHandler implements NodeHandler {
  readonly type = 'doc';

  render(
    _node: ContentNode | DocumentState,
    _parent: ContentNode | DocumentState | null,
    childContent: string,
    _ctx: RenderContext
  ): string {
    return childContent.trim();
  }
}
